


import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import sound from "../../../../images/alaram.mp3";
const Cheforder = () => {
  const [isHovered, setIsHovered] = useState(false);
  const [expandedOrder, setExpandedOrder] = useState(null);
  const [orders, setOrders] = useState([]);
  const [checkedItems, setCheckedItems] = useState({});
  const [vendorId, setVendorId] = useState(null);

  const scrollContainerRef = useRef(null);
  const [showTableDetails, setShowTableDetails] = useState({}); // ✅ track dine-in detail toggles
  const [selectedItems, setSelectedItems] = useState({});
  const [showExpanded, setShowExpanded] = useState({}); // <-- added for Table Info toggle
  const notificationSound = new Audio(sound);
  // ✅ Toggle handler for Table Info
  const handleToggleTableDetails = (uniqueId) => {
    setShowExpanded((prev) => ({
      ...prev,
      [uniqueId]: !prev[uniqueId], // toggle only this card
    }));
  };

  // ✅ Expand/collapse whole card
  // const handleOrderClick = (order) => {
  //   setExpandedOrder(
  //     expandedOrder && expandedOrder.orderId === order.orderId ? null : order
  //   );
  // };


  const handleOrderClick = (order) => {
    const id = order.orderId || order.cartId; // normalize ID
    // //("Clicked order:", order); // ✅ debug

    if (expandedOrder && expandedOrder.id === id) {
      // //("Collapsing order:", id);
      setExpandedOrder(null); // collapse
    } else {
      // //("Expanding order:", id);
      setExpandedOrder({ ...order, id }); // expand
    }
  };



  const handleCheckboxChange = (orderId, itemIndex) => {
    const key = `${orderId}-${itemIndex}`;
    setCheckedItems((prev) => ({
      ...prev,
      [key]: !prev[key],
    }));
  };


  useEffect(() => {
    const storedVendorId = localStorage.getItem("vendorId");
    setVendorId(storedVendorId);
  }, []);


  const handleAcceptOrderrsss = async (e, cartId, selectedItemIds = []) => {
    e.stopPropagation();

    const status = "BEING_PREPARED";
    const note = "Selected items accepted";
    const token = localStorage.getItem("authToken"); // ✅ Get token from localStorage

    if (!token) {
      alert("Authentication token is missing.");
      return;
    }

    if (selectedItemIds.length === 0) {
      alert("Please select at least one item to accept.");
      return;
    }

    const itemIdsParam = selectedItemIds.join("&itemIds=");
    const url = `https://backend.maamaas.com/food/api/cart/cart/status/${cartId}?itemIds=${itemIdsParam}&status=${status}&note=${encodeURIComponent(note)}`;

    try {
      const response = await fetch(url, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`, // ✅ Token added here
        },
      });

      if (!response.ok) throw new Error(`Error: ${response.status}`);

      const data = await response.json();
      //("✅ Selected items accepted:", data);
      window.location.reload();
      // Optional: refresh or update state here
    } catch (error) {
      console.error("❌ Failed to accept items:", error);
      alert("Failed to accept selected items. Please try again.");
    }
  };




  const handleAcceptOrderrss = async (e, itemId) => {
    e.stopPropagation();

    const status = "CANCELLED";
    const note = "sds"; // optional note 
    const url = `https://backend.maamaas.com/food/api/cart/cartitem/status/${itemId}?status=${status}&note=${encodeURIComponent(note)}`;

    try {
      const response = await fetch(url, {
        method: "PUT", // or POST depending on your API
        headers: {
          "Content-Type": "application/json",
        },
      });

      if (!response.ok) {
        throw new Error(`Error: ${response.status}`);
      }

      const data = await response.json();
      // //("✅ Status updated:", data);

      // Optional: update local state so UI reflects change
      // e.g., remove item from list or update its status
    } catch (error) {
      console.error("❌ Failed to update status:", error);
    }
  };



  useEffect(() => {
    const vendorId = localStorage.getItem("vendorId");
    const token = localStorage.getItem("authToken");
    const employeeRole = localStorage.getItem("employeRole"); // ✅ keep as-is
    const role = localStorage.getItem("role"); // ✅ new addition for ROLE_VENDOR


    if (!vendorId || !token) {
      console.warn("⚠️ Missing vendorId or token. Stopping fetchOrders.");
      return;
    }

    const fetchOrders = async () => {


      try {
        // 🔹 Fetch vendor orders
        const vendorRes = await axios.get(
          `https://backend.maamaas.com/food/api/orders/vendor/${vendorId}`,
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        );



        const pendingOrders = vendorRes.data.filter(
          (order) => order.status === "CONFIRMED"
        );

        const confirmedOrdersFromVendor = vendorRes.data.filter(
          (order) =>
            Array.isArray(order.cartItems) &&
            order.cartItems.some((item) => item.orderStatus === "PROCESSING")
        );

        // 🔹 Second API
        const confirmedRes = await axios.get(
          `https://backend.maamaas.com/food/api/cart/get/ordertype=TABLE_DINE_IN/${vendorId}/PROCESSING`,
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        );

        const confirmedOrdersDirect = confirmedRes.data || [];

        let allOrders = [
          ...pendingOrders,
          ...confirmedOrdersFromVendor,
          ...confirmedOrdersDirect,
        ];



        // ✅ List of all possible chef types
        const validChefTypes = [
          "Chef_North",
          "Chef_South",
          "Chef_Continental",
          "Chef_Chinese",
        ];

        // ✅ If the user role is ROLE_VENDOR → show all orders (skip filter)
        if (role === "ROLE_VENDOR") {
          console.log("👑 ROLE_VENDOR detected → showing all orders");

        }
        // ✅ Else, filter orders based on employeeRole (Chef types)
        else if (employeeRole) {
          console.log("🧠 Filtering orders for Employee Role:", employeeRole);

          allOrders = allOrders.filter((order) =>
            (order.cartItems || order.order)?.some(
              (item) => item.chefType && item.chefType === employeeRole
            )
          );

          const chefTypesFound = allOrders
            .flatMap((order) =>
              (order.cartItems || order.order)
                ?.filter((item) => item.chefType)
                .map((item) => item.chefType)
            )
            .filter(Boolean);




        } else {
          console.warn("⚠️ No employeeRole found — skipping filter & alert.");
          alert(
            `⚠️ No employee role found.\nPlease log in again or set one of the following roles:\n${validChefTypes.join(
              ", "
            )}`
          );
        }

        // 🔹 Avoid infinite re-renders
        setOrders((prevOrders) => {
          const previousOrderIds = prevOrders.map((o) => o.orderId || o.cartId);
          const newOrders = allOrders.filter(
            (o) => !previousOrderIds.includes(o.orderId || o.cartId)
          );

          if (newOrders.length > 0) {
            console.log("🔔 New Orders Detected:", newOrders);
            notificationSound
              .play()
              .catch((e) => console.warn("Autoplay prevented:", e));
          } else {
            console.log("ℹ️ No new orders found this round.");
          }

          return allOrders;
        });
      } catch (error) {
        console.error(
          "❌ Error fetching orders:",
          error.response?.data || error.message
        );
      }
    };

    fetchOrders();

    const interval = setInterval(fetchOrders, 10000);
    return () => clearInterval(interval);
  }, []);






  // 👈 watch vendorId changes

  // Auto-scroll logic
  useEffect(() => {
    const scrollContainer = scrollContainerRef.current;
    if (!scrollContainer) return;

    let interval;

    const startScrolling = () => {
      interval = setInterval(() => {
        if (!isHovered) {
          scrollContainer.scrollTop += 1;

          if (scrollContainer.scrollTop >= scrollContainer.scrollHeight / 2) {
            scrollContainer.scrollTop = 0;
          }
        }
      }, 20);
    };

    startScrolling();

    return () => clearInterval(interval);
  }, [isHovered]);

  const getOrderColor = (orderType) => {
    const normalized = (orderType || "").trim().toLowerCase();
    switch (normalized) {
      case "dine_in":
        return "#1E90FF";
      case "takeaway":
        return "#FF6347";
      case "delivery":
        return "#20B2AA";
      case "table_dine_in":
        return "#2051b2ff";
      default:
        return "#ccc";
    }
  };


  // Accept button handler
  const handleAcceptOrderr = async (e, orderId) => {
    e.stopPropagation();

    const token = localStorage.getItem("authToken"); // ✅ Retrieve token
    if (!token) {
      alert("Authentication token is missing.");
      return;
    }

    try {
      const response = await axios.put(
        `https://backend.maamaas.com/food/api/orders/edit-orders/${orderId}/PROCESSING`,
        {
          status: "PROCESSING", // send in body
        },
        {
          headers: {
            Authorization: `Bearer ${token}`, // ✅ Add token to headers
          },
        }
      );

      // //("Status updated:", response.data);
      window.location.reload();
      // Update local UI
      setOrders((prev) => prev.filter((order) => order.orderId !== orderId));
    } catch (error) {
      console.error("Failed to update order status:", error.response?.data || error.message);
    }
  };


  const handleDeclineOrder = async (e, orderId) => {
    e.stopPropagation();

    const token = localStorage.getItem("authToken");
    if (!token) {
      alert("Authentication token is missing.");
      return;
    }

    try {
      const response = await axios.put(
        `https://backend.maamaas.com/food/api/orders/cancal/total/order/${orderId}`,
        {}, // ✅ Empty body (if your API doesn’t need one)
        {
          headers: {
            Authorization: `Bearer ${token}`, // ✅ Correct placement
            "Content-Type": "application/json",
          },
        }
      );

      // //("✅ Status updated:", response.data);

      // ✅ Update UI after successful cancellation
      setOrders((prev) => prev.filter((order) => order.orderId !== orderId));

    } catch (error) {
      console.error(
        "❌ Failed to update order status:",
        error.response?.data || error.message
      );

      if (error.response?.status === 403) {
        alert("Access denied. Your session may have expired — please log in again.");
      }
    }
  };



  return (
    <div
      style={{
        position: "fixed",
        top: "110px",
        bottom: "20px",
        right: "16px",
        // width: "300px",
        borderRadius: "8px",
        padding: "10px",

        display: 'flex',
        flexDirection: 'column',
      }}
      className="mobilescroll"
    >
      <div
        style={{
          flexGrow: 1,
          overflowY: "auto",
          paddingRight: "5px",
          scrollbarWidth: "none",
          msOverflowStyle: "none",
        }}
        className="hide-scrollbar"
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
      >
        {orders.map((order, index) => {
          const uniqueId = order.orderId || order.cartId;
          const itemsList = order.items || order.order || order.cartItems || [];

          const isExpanded =
            expandedOrder &&
            (expandedOrder.orderId === uniqueId || expandedOrder.cartId === uniqueId);

          return (
            <div
              key={`${uniqueId}-${index}`}
              onClick={() => handleOrderClick(order)}
              className="card scroll-data-responsive"
              style={{
                cursor: "pointer",
                width: "300px",
                marginBottom: "10px",
                background: getOrderColor(order.orderType),
                borderRadius: "8px",
                boxShadow: "0px 2px 4px rgba(0,0,0,0.1)",
                padding: "10px",
                position: "relative",
                transition: "all 0.3s ease",
                height: isExpanded ? "auto" : "120px",
              }}
            >
              <div style={{ width: "100%" }}>
                {/* Header */}
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    color: "#fff",
                    fontWeight: "bold",
                  }}
                >
                  <p>Order ID: #{uniqueId}</p>
                  <h5 style={{ marginTop: "-15px" }}>{order.orderType || "N/A"}</h5>
                </div>

                {/* Items (expanded for TABLE_DINE_IN or cartId) */}
                {isExpanded && (
                  <div style={{ marginTop: "-10px" }}>
                    <h6 style={{ color: "#fff", fontSize: "20px" }}>Items:</h6>
                    <ul
                      style={{
                        listStyle: "none",
                        padding: 0,
                        marginLeft: "60px",
                        fontWeight: "bold",
                      }}
                    >



                      {itemsList.map((item, idx) => (
                        <li
                          key={idx}
                          style={{
                            color: "#000",
                            fontSize: "20px",
                            marginBottom: "8px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                          }}
                          onClick={(e) => e.stopPropagation()} // prevent collapse
                        >
                          <label style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                            <input
                              type="checkbox"
                              checked={!!checkedItems[`${uniqueId}-${idx}`]}
                              onClick={(e) => e.stopPropagation()} // prevent collapse
                              onChange={() => handleCheckboxChange(uniqueId, idx)}
                            />
                            {item.dishName || "Unnamed Dish"} ×{" "}
                            {order.orderType === "TABLE_DINE_IN"
                              ? item.updateQuantity || 0
                              : item.quantity || 0}
                          </label>
                        </li>
                      ))}

                    </ul>
                  </div>
                )}


                {order.orderType === "TABLE_DINE_IN" && (
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      marginTop: "10px",
                    }}
                  >
                    {/* Accept Selected Items */}
                    <button
                      onClick={(e) => {
                        e.stopPropagation();
                        // Get selected itemIds from checkedItems
                        const selectedItemIds = itemsList
                          .map((item, idx) =>
                            !!checkedItems[`${uniqueId}-${idx}`] ? item.itemId : null
                          )
                          .filter(Boolean);

                        if (selectedItemIds.length === 0) {
                          alert("Please select at least one item to accept.");
                          return;
                        }

                        // Pass selected items to your API
                        handleAcceptOrderrsss(e, order.cartId, selectedItemIds);
                      }}
                      style={{
                        padding: "8px",
                        backgroundColor: "rgb(177 93 198)",
                        color: "white",
                        fontSize: "14px",
                        fontWeight: "bold",
                        border: "none",
                        borderRadius: "5px",
                        cursor: "pointer",
                      }}
                    >
                      Accept
                    </button>

                    {/* Decline Button */}
                    <button
                      onClick={(e) => {
                        e.stopPropagation();
                        handleAcceptOrderrss(e, order.cartId);
                      }}
                      style={{
                        padding: "8px",
                        backgroundColor: "rgb(177 93 198)",
                        color: "white",
                        fontSize: "14px",
                        fontWeight: "bold",
                        border: "none",
                        borderRadius: "5px",
                        cursor: "pointer",
                      }}
                    >
                      Decline
                    </button>
                  </div>
                )}





                {/* Buttons for non-TABLE_DINE_IN orders */}
                {order.orderType !== "TABLE_DINE_IN" && (
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      marginTop: "10px",
                    }}
                  >
                    <button
                      onClick={(e) => handleAcceptOrderr(e, uniqueId)}
                      style={{
                        padding: "8px",
                        backgroundColor: "rgb(177 93 198)",
                        color: "white",
                        fontSize: "14px",
                        fontWeight: "bold",
                        border: "none",
                        borderRadius: "5px",
                        cursor: "pointer",
                      }}
                    >
                      Accept
                    </button>
                    <button
                      onClick={(e) => handleDeclineOrder(e, uniqueId)}
                      style={{
                        padding: "8px",
                        backgroundColor: "rgb(177 93 198)",
                        color: "white",
                        fontSize: "14px",
                        fontWeight: "bold",
                        border: "none",
                        borderRadius: "5px",
                        cursor: "pointer",
                      }}
                    >
                      Decline
                    </button>
                  </div>
                )}
              </div>
            </div>
          );
        })}
      </div>

    </div>

  );
};

export default Cheforder;

